import PlanContainer from './plan_container';

const Plan = PlanContainer;
export default Plan;
